import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

function CollapseToggler({
  onClick = () => {},
  isOpen = false
}) {

  const handleOnClick = () => {
    onClick();
  };

  return (
    <div
      className={`tbxCollapseToggler tbxCollapseToggler-${isOpen ? 'opened' : 'closed'}`}
      onClick={handleOnClick}
    >
      <div className="tbxCollapseToggler__circle">
        <div className="tbxCollapseToggler__line-horizontal"></div>
        <div className="tbxCollapseToggler__line-vertical"></div>
      </div>
    </div>
  );
};

CollapseToggler.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func
};

export default React.memo(CollapseToggler);
